import ModelUtil from '@leverege/model-util';
import { LogicCondition } from '@leverege/condition';
const TYPE = 'condition.Filter';
function create(extra) {
  return {
    rootCondition: null,
    ...extra,
    type: TYPE
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('rootCondition'),
  addCondition(model, condition) {
    if (model.rootCondition.type === LogicCondition.TYPE) {
      const nRootCondition = LogicCondition.addCondition(model.rootCondition, condition);
      return {
        ...model,
        rootCondition: nRootCondition
      };
    }
    return model;
  }
};